import { QueovalBase } from "./queoval.base";
import { ProspectInfo, ProspectStage, ProspectCycle } from "./classes.registration";
import { Cycle, Stage, Product, Responsable } from "./classes.catalogsformations";
import { Client, ConnectedUser, OptionalFieldDB, OptionalForm } from 'projects/lib-components/src/public_api';
import { WSAppSource, WSRegMode, WSUserRole } from './generic.data';
import { FicheCycle } from './cycle';

export class RegistrationModel extends QueovalBase {
  RegistrationMode: WSRegMode;
  Source: WSAppSource;
  ProspectData: ProspectInfo;
  InscriptionData: ProspectStage;
  InscriptionCycleData: ProspectCycle;
  SelectedClient: Client;
  CycleData: Cycle;
  StageData: Stage;
  ProductData: Product;
  SenderRole: WSUserRole;

  public OptionalFieldsCPPT: Array<OptionalForm>;
  public OptionalFieldsCNT: Array<OptionalForm>;

  public SuccessMessage: string;

  public ResponseSteps: RegistrationStepsResponse;

  constructor() {
    super();

    this.RegistrationMode = WSRegMode.NONE;
    this.Source = WSAppSource.NONE;
    this.ProspectData = new ProspectInfo;
    this.InscriptionData = new ProspectStage;
    this.InscriptionCycleData = new ProspectCycle;
    this.SenderRole = WSUserRole.NONE;
  }
}

export class RegistrationPortailModel extends QueovalBase {
  MailRegistration: RegistrationModel;
}

export class OptionalData {
  Contact: Array<OptionalFieldDB>;
  ProspectClient: Array<OptionalFieldDB>;
}

export class RegistrationStepsResponse {
  public MsgStep: string;
  public LogsList: Array<string>;

  public ProcessDataObject: ProcessDataDTO;
  public ProcessDataJson: string;
  public FormAuthorName: string;
  public FormAuthorMail: string;
  public AdministrateursList: Array<string>;
  public IsClient: boolean;
}

export class OutputDataDTO {
  public ProspectID: string;
  public ContactID: Array<string>;
  public DevisID: string;
  public ProjectID: string;
  public ActionCoID: string;
  public HistoriqueID: string;
}

export class ProcessDataDTO {
  public ProcessModus: ProcessMode;
  public RegistrationModus: eRegMode;

  public identSCP: string;
  public nameSCP: string;
  public numberSCP: string;
  public priceSC: string;
  public pricePosition: string;
  public ResponsablesList: Array<Responsable>;
  public ProspectOptionalFields: Array<OptionalForm>;
  public ContactOptionalFields: Array<OptionalForm>;
  public UserRole: WSUserRole;
  public ExtranetUser: ConnectedUser;
  public RaisonSo: string;
  public Civilite: string;
  public Nom: string;
  public Prenom: string;
  public Adr1: string;
  public Adr2: string;
  public Adr3: string;
  public CodePostal: string;
  public Ville: string;
  public NumTel: string;
  public FixTel: string;
  public Email: string;
  public SiteWeb: string;
  public Info: string;
  public LinkedProduct: Product;
  public LinkedStagesList: Array<FicheCycle>;
  public IsEntreprise: boolean;
  public ItemGender: string;
  public Output: OutputDataDTO;
}

export enum eRegMode {
  NONE,
  MIXED,
  PORTAIL
}

export enum ProcessMode {
  BYMAIL,
  ONDB
}
